import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { GoogleService } from '../services/auth/google/google.service';
import { LinkedinService } from '../services/auth/linkedin/linkedin.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Component({
  selector: 'app-login',

  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  showPassword = false;
  googleIcon = './assets/' + environment.projectName + '/icons/google.svg';
  logo = './assets/' + environment.projectName + '/media/header/logo.png';
  lang: string = '';
  user: any = { email: '', sub: '' };
  constructor(private linkedIn: LinkedinService, private google: GoogleService, private authService: AuthService, private userInfoService: UserInfoService, private route: ActivatedRoute) {
    this.route.params.subscribe((params) => {
      if (params) {
        this.lang = params['lang'];
      }
    });
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  loginAsUser() {
    this.authService.loginAsUser(this.user).subscribe((response: any) => {
      this.userInfoService.setUserInfo(response);
      window.location.href = '/';
    });
  }

  loginWithLinkedIn() {
    this.linkedIn.loginWithLinkedIn();
  }

  loginWithGoogle() {
    this.google.login();
  }
}
